<template>
  <!-- normal size -->
  <v-row
    v-if="$vuetify.display.mdAndUp"
    class="pt-5 pb-5"
  >
    <v-col
      class="text-h5"
      cols="5"
    >
      {{ title }}
    </v-col>

    <v-col>
      <template v-if="ol">
        <ol class="term-ol">
          <slot />
        </ol>
      </template>
      <template v-else>
        <slot />
      </template>
    </v-col>
  </v-row>

  <!-- small size -->
  <v-card
    v-else
    class="pt-5 pb-5"
    elevation="0"
  >
    <v-card-title class="text-h5">
      {{ title }}
    </v-card-title>

    <v-card-text class="mt-1 text-subtitle-1">
      <template v-if="ol">
        <ol class="term-ol">
          <slot />
        </ol>
      </template>
      <template v-else>
        <slot />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    ol: Boolean
  }
}
</script>

<style scoped>
.term-ol li {
  margin-bottom: 15px;
}
</style>
